/**
 * @generated SignedSource<<70d0803993d1d052e3926fbdd969669d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternScheduledBuildCardCancelMutation$variables = {
  brandId: string;
  platform: string;
};
export type InternScheduledBuildCardCancelMutation$data = {
  readonly cancelScheduledBuild: {
    readonly message: string;
    readonly success: boolean;
  };
};
export type InternScheduledBuildCardCancelMutation = {
  response: InternScheduledBuildCardCancelMutation$data;
  variables: InternScheduledBuildCardCancelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "platform"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "platform",
        "variableName": "platform"
      }
    ],
    "concreteType": "CancelScheduledBuildPayload",
    "kind": "LinkedField",
    "name": "cancelScheduledBuild",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternScheduledBuildCardCancelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternScheduledBuildCardCancelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "00bb58b9856697beea54d047d902318e",
    "id": null,
    "metadata": {},
    "name": "InternScheduledBuildCardCancelMutation",
    "operationKind": "mutation",
    "text": "mutation InternScheduledBuildCardCancelMutation(\n  $brandId: ID!\n  $platform: String!\n) {\n  cancelScheduledBuild(brandId: $brandId, platform: $platform) {\n    success\n    message\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9ab8c7fcb48fa45dcc3688dd68c7cad";

export default node;
